import { render } from "./VabenePageFormPage.vue?vue&type=template&id=60f091be&scoped=true&ts=true"
import script from "./VabenePageFormPage.vue?vue&type=script&lang=ts"
export * from "./VabenePageFormPage.vue?vue&type=script&lang=ts"

import "./VabenePageFormPage.vue?vue&type=style&index=0&id=60f091be&scoped=true&lang=css"
import "./VabenePageFormPage.vue?vue&type=style&index=1&id=60f091be&lang=css"
import "./VabenePageFormPage.vue?vue&type=style&index=2&id=60f091be&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f091be"]])

export default __exports__